import React from 'react';
import Type from 'prop-types';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { ru } from 'locale';
import useStyles from './ScoreItem.styles';

const ScoreItem = props => {
  const classes = useStyles();
  const { category } = props;
  return (
    <Card>
      <CardHeader title={category.title} titleTypographyProps={{ variant: 'h6' }} />

      <Divider />
      <CardContent className={classes.cardContent}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{ru.marker}</TableCell>
              <TableCell>{ru.value}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {category.markers.map(marker => (
              <TableRow key={marker.name}>
                <TableCell>{marker.name}</TableCell>
                <TableCell>{marker.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

ScoreItem.propTypes = {
  category: Type.shape({
    title: Type.string,
    markers: Type.arrayOf(
      Type.shape({
        name: Type.string.isRequired,
        value: Type.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default ScoreItem;
